import { generateUrl, AppSetup, safeParseJson } from "./base-window-setup.service.js";
const loadCmsScripts = async (fullPathName, apiCmsHost) => {
  if (!window.__ssr__) {
    return;
  }
  const response = await fetch(
    `${generateUrl(AppSetup.bootstrap, encodeURIComponent(fullPathName), apiCmsHost)}${window.isPrerender ? "&prerenderBuild=true" : ""}`
  );
  const { data = {} } = await safeParseJson(response);
  const { javaScripts = {} } = data;
  const { bodyJavaScript = "", headJavaScript = "", liveChat = "" } = javaScripts;
  window.bodyScripts = JSON.stringify(bodyJavaScript);
  window.headJavaScript = JSON.stringify(headJavaScript);
  window.liveChatScript = JSON.stringify(liveChat);
  return null;
};
export {
  loadCmsScripts
};
